import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'connected-react-router';
import Idle from 'react-idle';

class Idler extends Component {

    constructor( props ){
        super(props);

        this._returnToWelcome = this._returnToWelcome.bind(this);
    }

    _returnToWelcome() {
        const { returnToWelcome } = this.props;
        returnToWelcome();
    }

    render() {
        const { timeout } = this.props;

        return (
            <Idle timeout={ timeout } onChange={ this._returnToWelcome } />
        );
    }

}

Idler.defaultProps = {
    timeout: 35000
};

Idler.propTypes = {
    timeout: PropTypes.number.isRequired
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        returnToWelcome: () => {
            dispatch ( push ( process.env.PUBLIC_URL + '/' ) );
        }
    };
};

export default connect(null,mapDispatchToProps)(Idler);


// WEBPACK FOOTER //
// ./src/components/idler.js